import {
  Badge,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Title,
} from "@clipboard-health/ui-components";
import { APP_V2_USER_EVENTS, openBrowser } from "@src/appV2/lib";
import { openZendeskMessaging } from "@src/appV2/lib/ZendeskMessaging/openZendeskMessaging";
import { isZendeskMessagingUnread } from "@src/appV2/lib/ZendeskMessaging/utils";
import { useSupportLinks } from "@src/appV2/support/hooks/useSupportLinks";
import { useZendeskArticle } from "@src/appV2/Zendesk/useZendeskArticle";
import { USER_EVENTS } from "@src/constants";

import { TERMS_OF_SERVICE_URL } from "../../constants/urls";
import { logAccountPageMenuItemTapped } from "../utils";

interface AccountsPageSupportSectionProps {
  unreadCount: number;
}

export function AccountsPageSupportSection(props: AccountsPageSupportSectionProps) {
  const { unreadCount } = props;
  const { openArticle } = useZendeskArticle();
  const { helpCenterWorkerSupportLink } = useSupportLinks();

  return (
    <>
      <Title semibold component="h4">
        Support
      </Title>
      <ListItem divider>
        <ListItemButton
          onClick={async () => {
            logAccountPageMenuItemTapped(APP_V2_USER_EVENTS.OPENED_TERMS_OF_SERVICE);
            await openBrowser(TERMS_OF_SERVICE_URL);
          }}
        >
          <ListItemIcon iconType="info" />
          <ListItemText primary="Terms of Service" />
        </ListItemButton>
      </ListItem>

      <ListItem
        divider
        secondaryAction={
          isZendeskMessagingUnread() ? <Badge color="error" count={unreadCount} /> : undefined
        }
      >
        <ListItemButton
          onClick={async () => {
            logAccountPageMenuItemTapped(APP_V2_USER_EVENTS.OPENED_CONTACT_SUPPORT);
            await openZendeskMessaging();
          }}
        >
          <ListItemIcon iconType="text-bubble" />
          <ListItemText primary="Contact Support" />
        </ListItemButton>
      </ListItem>

      <ListItem divider>
        <ListItemButton
          onClick={async () => {
            logAccountPageMenuItemTapped(USER_EVENTS.OPENED_HELP_CENTER);
            await openArticle(helpCenterWorkerSupportLink);
          }}
        >
          <ListItemIcon iconType="info" />
          <ListItemText primary="Frequently asked questions" />
        </ListItemButton>
      </ListItem>
    </>
  );
}
